import { useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useSite } from "@/context/SiteContext";
import { FAQ_CATS } from "@/lib/api";

export const Faq = () => {
  const { site } = useSite();
  const [cat, setCat] = useState("");
  const faqs = site.faqs || [];
  if (!faqs.length) return null;
  const cats = Object.keys(FAQ_CATS).filter((k) => faqs.some((f) => f.category === k));
  const list = cat ? faqs.filter((f) => f.category === cat) : faqs;
  const chip = (active) => `shrink-0 rounded-full px-3 py-1.5 text-xs font-semibold border transition-colors ${active ? "bg-nanina-green text-white border-nanina-green" : "bg-white text-nanina-green border-nanina-line hover:bg-nanina-skysoft"}`;
  return (
    <section id="faq" className="pb-12 sm:pb-16" data-testid="faq-section">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-nanina-fresh">FAQ</p>
        <h2 className="mt-1 text-2xl sm:text-3xl font-extrabold tracking-tight text-nanina-green">Pertanyaan yang Sering Ditanyakan</h2>
        {cats.length > 1 && (
          <div className="mt-4 flex gap-2 overflow-x-auto nn-scroll-x pb-1" data-testid="faq-filters">
            <button onClick={() => setCat("")} className={chip(!cat)} data-testid="faq-filter-all">Semua</button>
            {cats.map((k) => <button key={k} onClick={() => setCat(k)} className={chip(cat === k)} data-testid={`faq-filter-${k}`}>{FAQ_CATS[k]}</button>)}
          </div>
        )}
        <Accordion type="single" collapsible className="mt-4 rounded-3xl bg-white border border-nanina-line px-4 sm:px-5">
          {list.map((f) => (
            <AccordionItem key={f.id} value={f.id} className="border-nanina-line last:border-b-0" data-testid={`faq-item-${f.id}`}>
              <AccordionTrigger className="text-left text-sm font-semibold text-nanina-green hover:no-underline py-3.5" data-testid={`faq-question-${f.id}`}>{f.question}</AccordionTrigger>
              <AccordionContent className="text-sm text-nanina-muted leading-relaxed whitespace-pre-line" data-testid={`faq-answer-${f.id}`}>{f.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
